import clsx from 'clsx'
import CountUp from 'react-countup'
import {useIntl} from 'react-intl'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {SwapperComponent} from '../../../assets/ts/components'
import {KTSVG} from '../../../helpers'
import {useMeter} from '../../../helpers/components/MeterProvider'
import UseRoutesPermission from '../../../hooks/UseRoutesPermission'
import {ROUTES} from '../../../constants/_routes'
import {ChecklistButton} from './ChecklistButton'
import {AccountButton} from './AccountButton'
import {SettingButton} from './SettingButton'

const Topbar = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const {meter} = useMeter()
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const {routes} = UseRoutesPermission()
  const isWalletActive = pathname === ROUTES.DEPOSITS.BASE

  return (
    <div className='d-flex align-items-center flex-shrink-0 w-sm-auto'>
      {currentUser && (
        <>
          <button
            type='button'
            className={clsx(
              'btn d-flex align-items-center flex-column justify-content-sm-between btn-sm fs-3 fw-boldest py-1 gori-wallet-btn balance-button w-100 w-xxl-auto',
              {
                'gori-wallet-btn--active balance-button--active': isWalletActive,
              }
            )}
            onClick={() => routes.DEPOSITS.hasPermission && navigate(ROUTES.DEPOSITS.BASE)}
          >
            <div className='ms-2 d-flex align-items-center'>
              <span>$</span>
              <CountUp
                start={0}
                end={meter?.balance}
                separator=','
                decimal={'.'}
                decimals={2}
                className='me-2'
              />
              <KTSVG path='/media/gori/topbar/payment-card.svg' className='svg-icon-2' />
            </div>
          </button>
          <div className='d-block'>
            <ChecklistButton />
          </div>
          <div className='d-block'>
            <SettingButton />
          </div>
          <div className='d-block'>
            <AccountButton />
          </div>
        </>
      )}

      {!currentUser && (
        <Link
          to={ROUTES.AUTH.LOGIN}
          onClick={() => SwapperComponent.removeInstances()}
          className='d-flex flex-stack'
        >
          <button type='button' className='btn btn-advanced-secondary rounded-pill px-5 px-md-8'>
            {intl.formatMessage({id: 'LOG_IN'})}
          </button>
        </Link>
      )}
    </div>
  )
}

export {Topbar}
